import { render, staticRenderFns } from "./RubricVersionLinkRenderer.vue?vue&type=template&id=d3f9456e&"
import script from "./RubricVersionLinkRenderer.vue?vue&type=script&lang=js&"
export * from "./RubricVersionLinkRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports